<template>
  <div class="search-right">
    <el-input
      v-model="searchText"
      :placeholder="$t('assist.placeEnter')"
      @keydown="handleKeydown"
      ref="inputRef"
    >
      <template #suffix>
        <i
          class="el-input__icon el-icon-close"
          v-if="searchText"
          @click="iconClick"
        ></i>
      </template>

      <template #append>
        <el-button @click="searchConcept">
          <img class="" src="@/common/image/assist/search.svg" alt="" />
        </el-button>
      </template>
    </el-input>
  </div>
</template>

<script lang="ts">
import router from '@/router'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  setup() {
    const searchText = ref('' as string)
    const inputRef = ref<HTMLInputElement>()
    const searchConcept = () => {
      if (searchText.value.trim()) {
        router.push(`/topicList/${searchText.value.trim()}`)
      } else {
        searchText.value = ''
      }
    }
    const handleKeydown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        searchConcept()
      }
    }

    const iconClick = () => {
      searchText.value = ''
      setTimeout(() => {
        inputRef.value?.focus()
      }, 200)
    }

    return {
      searchText,
      searchConcept,
      handleKeydown,
      iconClick,
      inputRef,
    }
  },
})
</script>

<style lang="less" scoped>
@import url(../../../../components/assist/index.less);
.search-right {
  width: 400px;
  padding-left: 20px;
  .el-button {
    width: 70px;
    height: 40px;
  }
  /deep/.el-input__inner {
    height: 40px;
    padding-left: 15px;
  }
  .el-icon-close {
    color: #0ca1bd;
    font-weight: 500;
    margin-top: 2px;
    cursor: pointer;
  }
  .el-icon-close:hover {
    font-weight: 600;
  }
}
</style>
